/**
 * PageHeader — FROZEN PUBLIC CONTRACT
 *
 * @public API (do not change without coordinating agent sign-off):
 *   @Input() eyebrow?: string      (small pre-title label, e.g. "Forwarding / Admin")
 *   @Input() title: string         (main page title — required)
 *   @Input() subtitle?: string     (secondary description line)
 *   <ng-content select="[actions]" />  (action buttons slot — placed on the right)
 *
 * Usage:
 *   <app-page-header title="Quotations" subtitle="Manage freight quotations">
 *     <button actions hlmBtn>New Quotation</button>
 *   </app-page-header>
 *
 *   <app-page-header eyebrow="Forwarding" title="Admin Panel">
 *     <button actions hlmBtn variant="outline">Export</button>
 *   </app-page-header>
 */
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-page-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex items-start justify-between gap-4 mb-6">
      <div class="min-w-0">
        @if (eyebrow()) {
          <p class="text-xs font-medium uppercase tracking-wider mb-1"
             style="color: rgb(var(--ds-mfg, 120 113 108))">
            {{ eyebrow() }}
          </p>
        }
        <h1 class="text-2xl font-semibold tracking-tight leading-tight"
            style="color: rgb(var(--ds-fg, 28 25 23))">
          {{ title() }}
        </h1>
        @if (subtitle()) {
          <p class="text-sm mt-1" style="color: rgb(var(--ds-mfg, 120 113 108))">
            {{ subtitle() }}
          </p>
        }
      </div>
      <div class="flex items-center gap-2 shrink-0">
        <ng-content select="[actions]" />
      </div>
    </div>
  `,
})
export class PageHeaderComponent {
  readonly eyebrow = input<string>('');
  readonly title = input.required<string>();
  readonly subtitle = input<string>('');
}
